import { AuthService } from "../service/auth.service";
import { Injectable } from "@angular/core";
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
} from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { TokenCookieService } from "../service/token-storage-cookies.service";
import { Router } from "@angular/router";
import { SnackbarService } from "src/app/shared/services/snackbar.service"; // adjust path to match your project

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(
    private router: Router,
    private tokenCookieService: TokenCookieService,
    private snackbar: SnackbarService
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((err: HttpErrorResponse) => {
        const message = this.resolveErrorMessage(err);
        this.snackbar.showNotification("snackbar-danger", message);

        if (err.status === 401) {
          // auto logout if 401 response returned from api
          this.router.navigate(["/supplier-authentication/signin"]);
          //location.reload();
        }

        return throwError(() => err);
      })
    );
  }

  private resolveErrorMessage(err: HttpErrorResponse): string {
    if (err.status === 0) {
      return "Please check your connection or try again shortly.";
    }
    if (err.status === 401) {
      return "Your session has expired. Please sign in again.";
    }
    if (err.status === 500) {
      return "Please ensure the username is valid or contact the System Administrator for assistance!";
    }
    if (err.error?.message) {
      return err.error.message;
    }
    return err.statusText || "Something went wrong. Please try again.";
  }
}